<template>
  <div class="w-full bg-primary text-white py-12">
    <div
      class="container flex space-x-10 flex-col lg:flex-row items-center justify-between"
    >
      <a
        href="https://www.prenatal.com/?utm_source=sito&utm_medium=landing&utm_campaign=happybox_logopnt"
        target="_blank"
        class="flex-shrink-0"
      >
        <img src="/images/prenatal-logo-white.png" class="h-8" alt="Prenatal" />
      </a>
      <p class="font-light text-sm text-center mt-5 lg:mt-0">
        © 2026 PRG Retail Group Portugal LDA. |
        <a v-if="locale === 'pt'" target="_blank" href="https://familycard.pt"
          >FAMILY CLUB</a
        >
        <a v-if="locale === 'es'" target="_blank" href="https://familycard.es"
          >FAMILY CLUB</a
        > |
        <a
          v-if="locale === 'pt'"
          href="https://familycard.pt/politica-de-privacidade"
          >{{ $t("footer.privacy_policy") }}</a
        >
        <a
          v-if="locale === 'es'"
          href="https://familycard.es/politica-de-privacidad"
          >{{ $t("footer.privacy_policy") }}</a
        >
      </p>
      <div class="flex space-x-5 items-center mt-10 lg:mt-0">
        <p class="font-medium leading-tight md:max-w-[8rem]">
          {{ $t("footer.socialShare") }}
        </p>
        <div
          class="bg-white rounded-full flex items-center justify-center w-14 h-14 flex-shrink-0 cursor-pointer"
          @click="modalStore.showModal()"
        >
          <img src="/icons/share.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n();
const modalStore = useModalStore();
</script>
